export default __webpack_public_path__ + "static/media/arras01min.630d1ad2.jpg";